import { Divider, Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { usePortfolioRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import type { ClientPropertyItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { PropertyListItemTitle } from "web_myplann/Portfolio/Components/PropertySections/PropertyListItemTitle";
import { PortfolioListItemRedesign } from "web_myplann/Portfolio/Components/Redesign/PortfolioListItemRedesign";
import { PortfolioItemKind } from "web_myplann/Portfolio/Types/portfolioItemKind";

type Props = {
	properties: ClientPropertyItemResponseDTO[];
};

export const DashboardPropertyList: FC<Props> = ({ properties }) => {
	const { spacingTokens } = useTheme();
	const navigate = useNavigate();
	const { hasRight: hasPortfolioRight } = usePortfolioRightOptional();

	return (
		<Stack
			gap={spacingTokens.lg}
			mt={spacingTokens.md}
			pb={spacingTokens.lg}
			divider={<Divider variant="hairline" />}
		>
			{properties.map((item) =>
				hasPortfolioRight ? (
					<PortfolioListItemRedesign
						key={item.id}
						item={{ kind: PortfolioItemKind.Property, data: item }}
						summaryData={undefined}
					/>
				) : (
					<PropertyListItemTitle
						key={item.id}
						data={item}
						onClick={() =>
							navigate(
								Routing.Portfolio.PropertyDetail.path(item.id.toString()),
							)
						}
					/>
				),
			)}
		</Stack>
	);
};
